var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconSecurityCel = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M34.7004 0H13.2989C11.5162 0 10.0571 1.45616 10.0571 3.24055V44.7571C10.0571 46.5427 11.5162 47.9994 13.2989 47.9994H34.6998C36.4824 47.9994 37.9421 46.5427 37.9421 44.7571V3.24055C37.9427 1.45616 36.483 0 34.7004 0ZM20.5762 2.33574H27.4231C27.6403 2.33574 27.8159 2.51247 27.8159 2.72972C27.8159 2.94462 27.6403 3.12019 27.4231 3.12019H20.5762C20.3601 3.12019 20.1839 2.94462 20.1839 2.72972C20.1839 2.51247 20.3601 2.33574 20.5762 2.33574ZM23.9999 46.3824C23.1062 46.3824 22.3787 45.6566 22.3787 44.7571C22.3787 43.8617 23.1045 43.1365 23.9999 43.1365C24.8953 43.1365 25.6205 43.8611 25.6205 44.7571C25.6205 45.656 24.8936 46.3824 23.9999 46.3824ZM35.6868 42.0027H12.3118V5.14003H35.6868V42.0027ZM23.7603 15.5052V32.3351C23.7603 32.3351 19.2492 28.6823 18.3467 26.9226C17.318 24.9116 17.0027 19.4944 17.6679 17.6936L23.7603 15.5052ZM30.3307 17.6906C30.9965 19.4915 30.6818 24.9104 29.6537 26.9197C28.7506 28.6794 24.2395 32.3321 24.2395 32.3321V15.5052L30.3307 17.6906Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSecurityCel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_security_cel.416133e0.svg";
export { ForwardRef as ReactComponent };